(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jp-deferred-widget"] && !Shopify.designMode) return;
  try {
    class JpDeferredWidget extends HTMLElement {
    connectedCallback() {
      if (this.dataset.activated === 'true') return;
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        if (window.Shopify?.designMode) {
          this.activate();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) this.activate();
        }, { rootMargin: '800px 0px' });
        this.observer.observe(this);
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
    }

    activate() {
      if (!this.isConnected || this.dataset.activated === 'true') return;
      const template = this.querySelector(':scope > template');
      if (!template) return;
      this.dataset.activated = 'true';
      this.observer?.disconnect();
      const fragment = template.content.cloneNode(true);
      const scripts = [...fragment.querySelectorAll('script')].map(original => {
        const marker = document.createElement('template');
        original.replaceWith(marker);
        return { original, marker };
      });
      template.replaceWith(fragment);
      for (const { original, marker } of scripts) {
        const script = document.createElement('script');
        for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
        script.async = original.hasAttribute('async');
        script.textContent = original.textContent;
        marker.replaceWith(script);
      }
    }
  }
  if (!customElements.get('jp-deferred-widget')) customElements.define('jp-deferred-widget', JpDeferredWidget);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-imersian-loader"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.Shopify?.designMode || window.jpImersianReady) return;

    window.jpImersianReady = new Promise((resolve, reject) => {
      const initialize = () => {
        try {
          const client = window.ImersianWebClient?.default || window.ImersianWebClient;
          if (!client?.config || !client?.init) throw new Error('Imersian SDK unavailable');
          client.config('ed058ec3-57da-4193-a07c-bac87f0e136b', 'viewer.imersian.com', 'shopify', 'ja');
          client.init();
          window.ImersianWebClient = client;
          resolve(client);
        } catch (error) {
          reject(error);
        }
      };

      let loading = false;
      const load = () => {
        if (loading) return;
        loading = true;
        if (window.ImersianWebClient) {
          initialize();
          return;
        }
        const existing = document.querySelector('script[src="https://static.imersian.com/bundled.js"]');
        const script = existing || document.createElement('script');
        script.addEventListener('load', initialize, { once: true });
        script.addEventListener('error', () => reject(new Error('Imersian SDK could not load')), { once: true });
        if (!existing) {
          script.src = 'https://static.imersian.com/bundled.js';
          script.async = true;
          document.head.appendChild(script);
        }
      };

      const schedule = () => {
        const sections = [...document.querySelectorAll('jp-imersian-inhome')];
        if (!sections.length) {
          load();
          return;
        }
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          load();
        }, { rootMargin: '800px 0px' });
        for (const section of sections) observer.observe(section.closest('.shopify-section') || section.parentElement);
      };

      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true });
    });

    window.jpImersianReady.catch(() => {});

    document.addEventListener('click', (event) => {
      const path = event.composedPath();
      if (!path.some((node) => node.id === 'shadow-quiz')) return;
      const trigger = path.find((node) => node.matches?.('[data-imersian-action="view-in-room"], [data-open-imersian]'));
      const variantId = trigger?.dataset.imersianVariantId || trigger?.dataset.imersianVariantid;
      if (!variantId) return;
      event.preventDefault();
      event.stopPropagation();
      window.jpImersianReady.then((client) => client.showImersianVisualiser(variantId)).catch(() => {});
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-journal-index"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.matches('[data-jp-journal-tag-filter]')) {
      window.location.assign(event.target.value);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-product-touch-video"] && !Shopify.designMode) return;
  try {
    class JPProductTouchVideo extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.surface = this.querySelector('.jp-product-touch-video__surface');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.updatePlayback();
      this.motion.addEventListener('change', this.onMotionChange);

      if (this.dataset.legacyEmbed) {
        try {
          const markup = new DOMParser().parseFromString(this.dataset.legacyEmbed, 'text/html');
          const source = markup.querySelector('iframe')?.getAttribute('src');
          const url = new URL(source);
          if (!['www.youtube.com', 'youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(url.hostname)) throw new Error();
          this.youtubeId = url.pathname.match(/^\/embed\/([a-zA-Z0-9_-]{11})\/?$/)?.[1];
          if (!this.youtubeId) throw new Error();
        } catch {
          this.hidden = true;
          return;
        }
      }

      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        this.updatePlayback();
      }, { threshold: 0.05 });
      this.observer.observe(this);
    }

    updatePlayback() {
      if (!this.surface) return;
      if (this.youtubeId) {
        if (!this.inView) {
          this.surface.replaceChildren();
          return;
        }
        const autoplay = this.motion.matches ? '0' : '1';
        if (this.surface.firstElementChild?.dataset.autoplay === autoplay) return;
        const iframe = document.createElement('iframe');
        const url = new URL(`https://www.youtube.com/embed/${this.youtubeId}`);
        url.search = new URLSearchParams({ autoplay, mute: '1', loop: '1', playlist: this.youtubeId, controls: '0', playsinline: '1', disablekb: '1', fs: '0', rel: '0' }).toString();
        iframe.src = url.href;
        iframe.title = this.getAttribute('aria-label');
        iframe.allow = 'autoplay; encrypted-media';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = -1;
        iframe.dataset.autoplay = autoplay;
        this.surface.replaceChildren(iframe);
        return;
      }
      if (this.inView && !this.surface.firstElementChild) {
        this.surface.append(this.querySelector('template').content.cloneNode(true));
      }
      const video = this.surface.querySelector('video');
      if (!video) return;
      video.muted = true;
      if (this.inView && !this.motion.matches) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.surface?.querySelector('video')?.pause();
    }
  }

  if (!customElements.get('jp-product-touch-video')) {
    customElements.define('jp-product-touch-video', JPProductTouchVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-size-customize"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-size-customize')) {
    customElements.define('jp-size-customize', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('input[type="range"]').forEach((input) => this.updateValue(input));
        this.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onInput);
      }

      onInput = (event) => {
        if (event.target instanceof HTMLInputElement && event.target.type === 'range') {
          this.updateValue(event.target);
        }
      };

      updateValue(input) {
        const output = input.closest('.jp-size-customize__field')?.querySelector('output');
        if (output) output.value = input.value;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-users-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-users-guide')) {
    customElements.define('jp-users-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const body = this.querySelector('[data-guide-body]');
        const desktop = this.querySelector('[data-guide-desktop]');
        const mobile = this.querySelector('[data-guide-mobile]');
        if (!body || !desktop || !mobile || !this.hasAttribute('data-show-toc')) return;
        const sourceLinks = [...body.querySelectorAll('.anchor-terms-guide a[href^="#"]')];
        const entries = [];
        sourceLinks.forEach(link => {
          const id = link.getAttribute('href').slice(1);
          const target = [...body.querySelectorAll('[id]')].find(node => node.id === id);
          if (!target) return;
          entries.push({ target, label: link.textContent.trim().replace(/について$/, '') });
          const warranty = [...target.querySelectorAll('h4')].find(node => node.textContent.trim() === '保証について');
          if (warranty) {
            if (!warranty.id) {
              let warrantyId = 'users-guide-warranty';
              while (document.getElementById(warrantyId)) warrantyId += '-section';
              warranty.id = warrantyId;
            }
            entries.push({ target: warranty, label: warranty.textContent.trim().replace(/について$/, '') });
          }
        });
        if (!entries.length) return;
        for (const container of [desktop, mobile]) {
          const nav = container.querySelector('nav');
          nav.replaceChildren();
          for (const entry of entries) {
            const link = document.createElement('a');
            link.textContent = entry.label;
            link.href = `#${encodeURIComponent(entry.target.id)}`;
            link.dataset.guideTarget = entry.target.id;
            nav.append(link);
          }
          container.hidden = false;
        }
        body.querySelectorAll('h3, h4, h5').forEach(heading => {
          heading.setAttribute('aria-level', String(Number(heading.tagName.slice(1)) - 1));
        });
        this.setAttribute('data-guide-ready', '');
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a[data-guide-target]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = entries.find(entry => entry.target.id === link.dataset.guideTarget)?.target;
          if (!target) return;
          event.preventDefault();
          mobile.open = false;
          if (location.hash !== link.hash) history.pushState(null, '', link.hash);
          this.moveTo(target, true);
        }, { signal: this.controller.signal });
        this.updateCurrent = () => {
          const stickyHeader = document.querySelector('header-component[data-sticky-state="active"]');
          const offset = (stickyHeader?.getBoundingClientRect().bottom || 0) + 90;
          let current = entries[0];
          for (const entry of entries) if (entry.target.getBoundingClientRect().top <= offset) current = entry;
          this.querySelectorAll('a[data-guide-target]').forEach(link => {
            if (link.dataset.guideTarget === current.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        };
        this.onScroll = () => {
          this.refreshAlignment?.();
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.updateCurrent(); });
        };
        this.cancelNavigation = () => {
          this.navigation = (this.navigation || 0) + 1;
          this.resizeAlignment = null;
          this.refreshAlignment = null;
          this.finishAlignment = null;
          if (this.anchorFrame) cancelAnimationFrame(this.anchorFrame);
          this.anchorFrame = null;
        };
        this.moveTo = (target, focus = false) => {
          this.cancelNavigation();
          const navigation = this.navigation;
          const hash = `#${encodeURIComponent(target.id)}`;
          let needsFocus = focus;
          let alignedScrollY;
          let alignedWidth;
          let alignedTop;
          let settlingUntil;
          const align = () => {
            if (this.navigation !== navigation || !this.isConnected || location.hash !== hash) return;
            if (this.anchorFrame) cancelAnimationFrame(this.anchorFrame);
            this.anchorFrame = requestAnimationFrame(() => {
              this.anchorFrame = null;
              if (this.navigation !== navigation || !this.isConnected || location.hash !== hash) return;
              target.scrollIntoView({ block: 'start', behavior: 'instant' });
              alignedScrollY = window.scrollY;
              alignedWidth = window.innerWidth;
              alignedTop = target.getBoundingClientRect().top;
              settlingUntil = window.performance.now() + 1000;
              if (needsFocus) {
                const headings = 'h1, h2, h3, h4, h5, h6, [role="heading"]';
                const heading = target.matches(headings) ? target : target.querySelector(headings);
                const focusTarget = heading || target;
                if (!heading && !focusTarget.hasAttribute('aria-label')) {
                  const label = entries.find(entry => entry.target === target)?.label;
                  if (label) focusTarget.setAttribute('aria-label', label);
                }
                focusTarget.setAttribute('tabindex', '-1');
                focusTarget.focus({ preventScroll: true });
                needsFocus = false;
              }
              this.updateCurrent();
            });
          };
          this.refreshAlignment = () => {
            if (alignedWidth === undefined || window.innerWidth !== alignedWidth) return;
            const style = window.getComputedStyle(target);
            const margin = parseFloat(style.scrollMarginTop) || 0;
            const top = target.getBoundingClientRect().top;
            const destination = window.scrollY + top - margin;
            const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
            const settlingDistance = (parseFloat(style.lineHeight) || parseFloat(style.fontSize) || 16) / 2;
            if (Math.abs(window.scrollY - Math.max(0, Math.min(destination, maximum))) <= 1 || (window.performance.now() <= settlingUntil && Math.abs(top - alignedTop) <= settlingDistance)) alignedScrollY = window.scrollY;
            else if (Math.abs(window.scrollY - alignedScrollY) > 1) alignedScrollY = undefined;
          };
          this.finishAlignment = () => {
            settlingUntil = window.performance.now() + 1000;
            this.refreshAlignment?.();
          };
          this.resizeAlignment = () => {
            if (alignedScrollY === undefined) return;
            const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
            if (Math.abs(window.scrollY - Math.min(alignedScrollY, maximum)) <= 1) align();
          };
          align();
          if (document.fonts?.status === 'loading') document.fonts.ready.then(align);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true, signal: this.controller.signal });
        window.addEventListener('load', () => this.finishAlignment?.(), { signal: this.controller.signal });
        this.viewportWidth = window.innerWidth;
        window.addEventListener('resize', () => {
          if (window.innerWidth !== this.viewportWidth) {
            this.viewportWidth = window.innerWidth;
            this.resizeAlignment?.();
          }
          this.onScroll();
        }, { signal: this.controller.signal });
        for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
          window.addEventListener(type, this.cancelNavigation, { passive: true, signal: this.controller.signal });
        }
        this.restoreHash = () => {
          this.cancelNavigation();
          const target = entries.find(entry => location.hash === `#${encodeURIComponent(entry.target.id)}`)?.target;
          if (!target) return;
          mobile.open = false;
          this.moveTo(target);
        };
        window.addEventListener('hashchange', this.restoreHash, { signal: this.controller.signal });
        const header = document.querySelector('header-component');
        if (header) {
          this.headerObserver = new MutationObserver(this.onScroll);
          this.headerObserver.observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
        }
        body.querySelectorAll('img').forEach(image => image.addEventListener('load', this.onScroll, { signal: this.controller.signal }));
        this.updateCurrent();
        this.restoreHash();
      }
      disconnectedCallback() {
        this.cancelNavigation?.();
        this.headerObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.anchorFrame) cancelAnimationFrame(this.anchorFrame);
        this.frame = null;
        this.anchorFrame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-wishlist-network"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-wishlist-network')) {
    customElements.define('jp-wishlist-network', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const options = { signal };
        const notice = this.querySelector('[role="alert"]');
        const message = notice?.querySelector('p');
        const reload = notice?.querySelector('[data-reload]');
        if (!notice || !message || !reload) return;
        const controls = 'button.swym-add-to-wishlist, button.swym-wishlist-collections-v2, .swym-delete-btn';
        let trigger;
        let pending;
        let ready = false;
        const unconfirmedVariants = this.unconfirmedVariants ||= new Set();
        const variantOf = (control) => {
          if (!control.matches('button.swym-add-to-wishlist')) return;
          const inputs = control.closest('.product-details')?.querySelectorAll('product-form-component input[name="id"]');
          const variants = new Set(Array.from(inputs || [], (input) => input.value).filter((value) => /^\d+$/.test(value)));
          if (variants.size === 1) return variants.values().next().value;
        };
        const clearPending = () => {
          clearTimeout(pending?.timer);
          pending = undefined;
        };
        const discardPending = () => {
          if (pending) unconfirmedVariants.add(pending.variant);
          clearPending();
        };
        signal.addEventListener('abort', discardPending, { once: true });
        window.SwymCallbacks = window.SwymCallbacks || [];
        window.SwymCallbacks.push((swat) => {
          if (signal.aborted || ready) return;
          const layer = swat?.evtLayer;
          if (!layer?.addEventListener || !layer.removeEventListener) return;
          // Swym keeps swym-adding after success. Only add completion acknowledges this add watchdog.
          const completed = (event) => {
            if (!pending || String(event.detail?.d?.epi) !== pending.variant) return;
            if (trigger === pending.control && reload.hidden === false) notice.hidden = true;
            clearPending();
          };
          layer.addEventListener('sw:addedtowishlist', completed);
          ready = true;
          signal.addEventListener('abort', () => {
            layer.removeEventListener('sw:addedtowishlist', completed);
          }, { once: true });
        });
        window.addEventListener('click', (event) => {
          const control = event.composedPath()[0]?.closest?.(controls);
          if (!control) return;
          const variant = variantOf(control);
          // SDK events carry no operation ID. Never acknowledge a later overlapping edit with an earlier event.
          discardPending();
          if (navigator.onLine !== false) {
            notice.hidden = true;
            reload.hidden = true;
            // An already-added heart can open app UI rather than start a save. Watch only new additions.
            if (ready && !control.disabled && !control.classList.contains('swym-added') && variant && !unconfirmedVariants.has(variant)) {
              const action = { control, variant };
              pending = action;
              action.timer = setTimeout(() => {
                if (pending !== action || !control.isConnected || variantOf(control) !== variant) return;
                trigger = control;
                message.textContent = this.dataset.pending;
                reload.hidden = false;
                notice.hidden = false;
              }, 15000);
            }
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          trigger = control;
          message.textContent = this.dataset.offline;
          reload.hidden = true;
          notice.hidden = false;
        }, { ...options, capture: true });
        window.addEventListener('online', () => {
          if (!notice.hidden && reload.hidden) message.textContent = this.dataset.reconnected;
        }, options);
        notice.querySelector('[data-dismiss]')?.addEventListener('click', () => {
          discardPending();
          notice.hidden = true;
          if (trigger?.isConnected) trigger.focus();
        }, options);
        reload.addEventListener('click', () => window.location.reload(), options);
      }

      disconnectedCallback() {
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jp-wishlist-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-wishlist-page')) {
    customElements.define('jp-wishlist-page', class extends HTMLElement {
      connectedCallback() {
        this.main = document.querySelector('#MainContent');
        if (!this.main) return;
        this.formatYen = new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 });
        this.areaPrices = new Map();
        this.areaPriceRequests = new Set();
        this.areaPriceRetryAt = new Map();
        this.observer = new MutationObserver(() => this.scheduleUpdate());
        this.observer.observe(this.main, { childList: true, subtree: true, characterData: true });
        this.update();
      }

      areaPriceFor(group) {
        const href = group.closest('.swym-wishlist-item')?.querySelector('a.swym-wishlist-image-wrapper')?.href;
        if (!href) return null;
        const productUrl = new URL(href, location.origin);
        const shopOrigin = new URL(this.dataset.shopOrigin || location.origin).origin;
        if (![location.origin, shopOrigin].includes(productUrl.origin) || !/^\/products\/[^/]+\/?$/.test(productUrl.pathname)) return null;
        const key = productUrl.pathname;
        if (!this.areaPriceRequests.has(key) && Date.now() >= (this.areaPriceRetryAt.get(key) || 0)) {
          this.areaPriceRequests.add(key);
          const url = new URL(key, location.origin);
          url.searchParams.set('view', 'recently-viewed');
          const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
          if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
          fetch(url, { signal: AbortSignal.timeout(8000) })
            .then(response => {
              if (!response.ok) throw new Error('Product price unavailable');
              return response.json();
            })
            .then(product => {
              const html = new DOMParser().parseFromString(product.price_html || '', 'text/html');
              const raw = html.querySelector('[data-jp-area-price-value]')?.getAttribute('data-jp-area-price-value');
              const amount = raw == null ? NaN : Number(raw);
              this.areaPrices.set(key, Number.isFinite(amount) && amount >= 0 ? amount : null);
            })
            .catch(() => {
              this.areaPrices.set(key, null);
              this.areaPriceRequests.delete(key);
              this.areaPriceRetryAt.set(key, Date.now() + 30000);
            })
            .finally(() => {
              if (this.isConnected) this.scheduleUpdate();
            });
        }
        return this.areaPrices.get(key);
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const root = this.main.querySelector('.swym-wishlist-page');
        if (!root) return;
        for (const group of root.querySelectorAll('.swym-product-price')) {
          if (group.classList.contains('swym-price-loading')) continue;
          const areaPrice = this.areaPriceFor(group);
          let output = group.querySelector(':scope > .jp-wishlist-price-output');
          if (typeof areaPrice === 'number') {
            if (output?.dataset.areaPrice === String(areaPrice)) continue;
            if (!output) {
              output = document.createElement('div');
              output.className = 'jp-wishlist-price-output';
              group.append(output);
            }
            output.dataset.areaPrice = String(areaPrice);
            const value = document.createElement('span');
            value.append(document.createTextNode(`￥ ${this.formatYen.format(areaPrice)} / m`));
            const exponent = document.createElement('sup');
            exponent.textContent = '2';
            value.append(exponent);
            output.replaceChildren(value);
            continue;
          }
          const prices = [...group.querySelectorAll('.swym-value')].map(price => {
            const match = price.textContent.trim().match(/^[¥￥]\s*([\d,]+(?:\.\d+)?)$/);
            const amount = match ? Number(match[1].replaceAll(',', '')) : NaN;
            return { price, amount };
          });
          if (!prices.length || prices.some(({ amount }) => !Number.isFinite(amount))) {
            output?.remove();
            continue;
          }
          const text = prices.map(({ amount }) => `¥${this.formatYen.format(amount)}`).join(' ');
          if (output?.textContent === text) continue;
          if (!output) {
            output = document.createElement('div');
            output.className = 'jp-wishlist-price-output';
            group.append(output);
          }
          delete output.dataset.areaPrice;
          output.replaceChildren(...prices.flatMap(({ price, amount }, index) => {
            const value = document.createElement('span');
            value.className = price.classList.contains('swym-product-original-price')
              ? 'jp-wishlist-original-price' : 'jp-wishlist-final-price';
            value.textContent = `¥${this.formatYen.format(amount)}`;
            return index ? [document.createTextNode(' '), value] : [value];
          }));
        }

        for (const item of root.querySelectorAll('.swym-wishlist-item')) {
          const imageLink = item.querySelector('a.swym-wishlist-image-wrapper');
          const button = item.querySelector('.swym-add-to-cart-btn');
          if (!imageLink || !button) continue;
          button.inert = true;
          if (item.querySelector('.swym-price-loading') || !item.querySelector('.swym-product-price .swym-value')) continue;
          const url = new URL(imageLink.href, location.origin);
          if (!/^\/products\/[^/]+\/?$/.test(url.pathname)) continue;
          const href = `${url.pathname}${url.search}${url.hash}`;
          let link = item.querySelector('.jp-wishlist-product-link');
          if (!link) {
            link = document.createElement('a');
            link.className = 'jp-wishlist-product-link';
            link.textContent = this.dataset.productLabel;
            link.addEventListener('click', event => event.stopPropagation());
            link.addEventListener('keydown', event => {
              if (event.key === 'Enter' || event.key === ' ') event.stopPropagation();
            });
            button.after(link);
          }
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
          let stock = item.querySelector('.jp-wishlist-stock-status');
          if (button.disabled && !stock) {
            stock = document.createElement('span');
            stock.className = 'jp-wishlist-stock-status';
            stock.textContent = button.textContent;
            link.before(stock);
          } else if (!button.disabled && stock) {
            stock.remove();
          }
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class JpColorStrip extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.section = this.closest('.shopify-section');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!matchMedia('(max-width: 749px)').matches) return;
          const label = this.querySelector('input:checked')?.closest('label');
          if (!label) return;
          const outer = this.getBoundingClientRect();
          const inner = label.getBoundingClientRect();
          if (inner.left < outer.left + 6) this.scrollLeft += inner.left - outer.left - 6;
          else if (inner.right > outer.right - 6) this.scrollLeft += inner.right - outer.right + 6;
        });
      };
      this.section?.addEventListener('variant:update', this.schedule, { signal: this.abort.signal });
      this.addEventListener('change', this.schedule, { signal: this.abort.signal });
      this.schedule();
    }
    disconnectedCallback() { this.abort.abort(); cancelAnimationFrame(this.frame); }
  }
  if (!customElements.get('jp-color-strip')) customElements.define('jp-color-strip', JpColorStrip);

  const rugPreviewImages = new Map();

  const findRugPreviewInput = (target) => {
    if (!(target instanceof Element)) return;
    const input = target.matches('input[data-rug-preview-url]')
      ? target
      : target.closest('label')?.querySelector('input[data-rug-preview-url]');
    return input instanceof HTMLInputElement ? input : undefined;
  };

  const preloadRugPreview = (input, priority = 'low') => {
    const previewUrl = input.dataset.rugPreviewUrl;
    if (!previewUrl) return;

    const existingImage = rugPreviewImages.get(previewUrl);
    if (existingImage) {
      if (priority === 'high') existingImage.fetchPriority = 'high';
      return;
    }

    const previewImage = new Image();
    previewImage.decoding = 'async';
    previewImage.fetchPriority = priority;
    previewImage.src = previewUrl;
    rugPreviewImages.set(previewUrl, previewImage);
  };

  const preloadRugColorImages = () => {
    const inputs = document.querySelectorAll(
      'variant-picker[data-template-product-match="true"] [data-rug-image-swatches="true"] input[data-rug-preview-url]'
    );

    for (const input of inputs) {
      if (input instanceof HTMLInputElement && !input.checked) preloadRugPreview(input);
    }
  };

  const scheduleRugColorPreload = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadRugColorImages, { timeout: 2000 });
    } else {
      window.setTimeout(preloadRugColorImages, 1000);
    }
  };

  if (document.readyState === 'complete') {
    scheduleRugColorPreload();
  } else {
    window.addEventListener('load', scheduleRugColorPreload, { once: true });
  }

  for (const eventName of ['pointerover', 'pointerdown', 'focusin']) {
    document.addEventListener(eventName, (event) => {
      const input = findRugPreviewInput(event.target);
      if (input) preloadRugPreview(input, 'high');
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.closest('[data-rug-image-swatches="true"]')) return;

    const picker = input.closest('variant-picker[data-template-product-match="true"]');
    const previewUrl = input.dataset.rugPreviewUrl;
    if (!picker || !previewUrl) return;
    preloadRugPreview(input, 'high');

    const gallery = picker.closest('.shopify-section')?.querySelector('media-gallery');
    const firstImages = [
      gallery?.querySelector('slideshow-component slideshow-slide img.product-media__image'),
      gallery?.querySelector('.media-gallery__grid > li img.product-media__image'),
    ];

    for (const image of firstImages) {
      if (!(image instanceof HTMLImageElement)) continue;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.fetchPriority = 'high';
      image.src = previewUrl;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
